(function () {
  function initFlashSale(sectionId) {
    var clock = document.getElementById('flashCountdown-' + sectionId);
    if (clock) {
      var targetDate = clock.getAttribute('data-target-date');
      var targetTime = clock.getAttribute('data-target-time');
      var target     = new Date(targetDate + 'T' + targetTime);

      function tick() {
        var now  = new Date();
        var diff = target - now;
        if (diff <= 0) {
          clock.innerHTML = '<li>Offer Ended</li>';
          return;
        }
        var d   = Math.floor(diff / 864e5);
        var h   = Math.floor((diff % 864e5) / 36e5);
        var m   = Math.floor((diff % 36e5) / 6e4);
        var s   = Math.floor((diff % 6e4) / 1e3);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        clock.querySelector('[data-days]').textContent    = pad(d);
        clock.querySelector('[data-hours]').textContent   = pad(h);
        clock.querySelector('[data-minutes]').textContent = pad(m);
        clock.querySelector('[data-seconds]').textContent = pad(s);
      }

      tick();
      setInterval(tick, 1000);
    }

    var swiperEl = document.querySelector('[data-flash-swiper="' + sectionId + '"]');
    if (swiperEl && typeof Swiper !== 'undefined') {
      var swiper = new Swiper(swiperEl, {
        loop: true,
        slidesPerView: 1.3,
        spaceBetween: 30,
        navigation: {
          nextEl: '[data-flash-next="' + sectionId + '"]',
          prevEl: '[data-flash-prev="' + sectionId + '"]',
        },
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
        breakpoints: {
          480:  { slidesPerView: 1.5},
          550:  { slidesPerView: 2},
          990:  { slidesPerView: 2.5},
          1200: { slidesPerView: 3},
          1400: { slidesPerView: 4}
        },
      });

      swiper.on('navigationUpdate', function () {
        var prevBtn = document.querySelector('[data-flash-prev="' + sectionId + '"]');
        var nextBtn = document.querySelector('[data-flash-next="' + sectionId + '"]');
        if (prevBtn) prevBtn.classList.toggle('swiper-button-disabled', swiper.isBeginning && !swiper.params.loop);
        if (nextBtn) nextBtn.classList.toggle('swiper-button-disabled', swiper.isEnd     && !swiper.params.loop);
      });
    }
  }

  function getSectionIds() {
    return Array.from(
      document.querySelectorAll('.flash-sale-section[data-section-id]')
    ).map(function (el) {
      return el.getAttribute('data-section-id');
    });
  }

  function onLoad() {
    var ids = getSectionIds();
    if (!ids.length) return;

    function run() {
      ids.forEach(function (id) { initFlashSale(id); });
    }

    if (typeof Swiper !== 'undefined') {
      run();
    } else {
      document.addEventListener('swiper:ready', run);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.flash-sale-section[data-section-id]');
    if (!el) return;
    var id = el.getAttribute('data-section-id');
    if (typeof Swiper !== 'undefined') {
      initFlashSale(id);
    } else {
      document.addEventListener('swiper:ready', function () { initFlashSale(id); });
    }
  });
})();